import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import { CLOSE } from '@Images';

const Modal = styled.div`
  width: 700px;
  height: 90%;
  border-radius: 5px;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  padding: 50px 20px 20px 40px;
  overflow: auto;
`;

const CloseImage = styled.div`
  display: flex;
  justify-content: flex-end;

  > img {
    cursor: pointer;
    height: 16px;
    width: 16px;
  }
`;

const Title = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.black};
  padding-left: 20px;
  padding-bottom: 10px;
`;

const ListContainer = styled.ul`
  list-style-type: disc;
  line-height: 1.47;
  padding-left: 20px;
  letter-spacing: 0.36px;
`;

const List = styled.li`
  font-size: 17px;
  color: ${COLORS.textGrey};
  padding-top: 10px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

const ValidCashPayoutIDList = ({ onClose }) => {
  return (
    <Modal>
      <CloseImage>
        <img onClick={() => onClose(true)} alt={'close'} src={CLOSE}></img>
      </CloseImage>
      <Title>The following are valid IDs</Title>
      <ListContainer>
        <List>Passport</List>
        <List>{"Driver's license with photo"}</List>
        <List>Professional Regulation Commission (PRC) ID</List>
        <List>National Bureau of Investigation (NBI) Clearance</List>
        <List>Police Clearance Certificate</List>
        <List>Postal ID</List>
        <List>Voter’s ID</List>
        <List>Barangay Certification</List>
        <List>Government Service Insurance System (GSIS) e-Card</List>
        <List>Social Security System (SSS) Card</List>
        <List>Senior Citizen Card</List>
        <List>Overseas Workers Welfare Administration (OWWA) ID</List>
        <List>OFW ID</List>
        <List>Seaman’s Book and Seafarer’s Registration Certificate</List>
        <List>Alien Certification of Registration/Immigrant Certificate of Registration</List>
        <List>
          Government Office and GOCC ID, e.g. Armed forces of the Philippines (AFP ID), Home
          Development Mutual Fund (HDMF ID)
        </List>
        <List>
          Certification from the National Council for the Welfare of Disabled Persons (NCWDP)
        </List>
        <List>Department of Social Welfare and Development (DSWD) Certification</List>
        <List>Integrated Bar of the Philippines ID</List>
        <List>
          Company IDs issued by private entities or institutions registered with or supervised or
          regulated either by the BSP, SEC or IC
        </List>
      </ListContainer>
    </Modal>
  );
};

ValidCashPayoutIDList.propTypes = {
  onClose: PropTypes.func
};

export default ValidCashPayoutIDList;
